import React, { Component } from "react";
import Datas from "../data/hero/hero-slider.json";
import Swiper from "react-id-swiper";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/heroSlider.js";

class HeroSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoPlaying: false,
    };
    this.videoRef = React.createRef();
  }

  componentDidMount() {
    const video = this.videoRef.current;
    if (video) {
      video.preload = "auto";
      video.muted = true;
      video.playsInline = true;

      video.addEventListener("canplaythrough", () => {
        video.play().catch(() => {});
        this.setState({ videoPlaying: true });
      });
    }
  }

  render() {
    const data = Datas[0];
    const { videoPlaying } = this.state;

    return (
      <Styles>
        <section className="hero-slider-area">
          <Swiper>
            <div className="slider-item">
              <div className="video-container">
                {!videoPlaying && (
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      `/assets/images/${data.backgroundImage}`
                    }
                    alt={data.backgroundImage}
                    className="slider-image"
                  />
                )}

                <video
                  ref={this.videoRef}
                  className="slider-video"
                  src="/assets/images/bannerVideo/bannerVideo.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                />
                <div className="video-overlay"></div>
              </div>

              <div className="slider-table">
                <div className="slider-tablecell">
                  <Container>
                    <Row>
                      <Col md="12">
                        <div className={data.uniqClass}>
                          <div className="slider-title">
                            <p>{data.title}</p>
                          </div>
                          <div className="slider-desc">
                            <h1>{data.desc}</h1>
                          </div>
                          <div className="slider-desc2">
                            <h1>{data.desc2}</h1>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
            </div>
          </Swiper>
        </section>
      </Styles>
    );
  }
}

export default HeroSlider;
